import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import throttle from 'lodash/throttle'

import { selectors as UISelectors } from 'data/ui'
import { selectors as ThreadsSelectors } from 'data/threads'
import { actions as ThreadsActions } from 'data/threads'

import { providesCreateThreadWithStatus } from '../dataSync'

import CommentCreator from '../Comment/Creator'

class ThreadsCreator extends Component {
  static propTypes = {
    createThread: PropTypes.func.isRequired,
    noteId: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.onChange = throttle(this.onChange, 300)
  }

  sendComment = (content, entities) => {
    const { noteId, createThread } = this.props
    createThread({
      thread: {
        noteId,
        content,
        entities,
      },
    })
    this.props.setThreadDraft({ key: this.props.noteId, content: '' })
  }

  onChange = content => {
    this.props.setThreadDraft({ key: this.props.noteId, content })
  }

  render() {
    return (
      <div className="padding-top-normal">
        <CommentCreator
          onSubmit={this.sendComment}
          onChange={this.onChange}
          threadDraft={this.props.threadDraft}
          placeholder={'Start a new thread'}
          startOfThread
          sendStatus={this.props.createCommentStatus}
        />
      </div>
    )
  }
}

const mapDispatchToProps = {
  setThreadDraft: ThreadsActions.setThreadDraft,
}
const ThreadCreatorConnected = compose(
  connect(
    state => {
      const noteId = UISelectors.getActiveNoteId(state)
      const threadDraft = ThreadsSelectors.getThreadDraft(state, noteId)
      return {
        noteId,
        threadDraft,
      }
    },
    mapDispatchToProps
  ),
  providesCreateThreadWithStatus
)(ThreadsCreator)

export default ThreadCreatorConnected
